import * as http from '../../modules/http';
import * as UrlParamsManager from '../../modules/UrlParamsManager';

export const PRIZE_REQUEST_START = 'PRIZE_REQUEST_START';
export const PRIZE_REQUEST_SUCCESS = 'PRIZE_REQUEST_SUCCESS';
export const PRIZE_REQUEST_FAILED = 'PRIZE_REQUEST_FAILED';
export const PRIZE_REQUEST_NO_PERMISSION = 'PRIZE_REQUEST_NO_PERMISSION';
export const PRIZE_OPEN_UPDATE_FORM = 'PRIZE_OPEN_UPDATE_FORM';
export const PRIZE_DELETE = 'PRIZE_DELETE';
export const PRIZE_UPDATE = 'PRIZE_UPDATE';
export const PRIZE_INSERT = 'PRIZE_INSERT';
export const PRIZE_UPDATE_FIELD = 'PRIZE_UPDATE_FIELD';
export const PRIZE_STORES_DAY = 'PRIZE_STORES_DAY';
export const PRIZE_STORES_DAY_UPDATE = 'PRIZE_STORES_DAY_UPDATE';
export const PRIZE_STORES_DAY_MANAGER = 'PRIZE_STORES_DAY_MANAGER';
export const PRIZE_STORES_DAY_MANAGER_ADD = 'PRIZE_STORES_DAY_MANAGER_ADD';
export const PRIZE_STORES_DAY_MANAGER_UPDATE = 'PRIZE_STORES_DAY_MANAGER_UPDATE';

export function prize_request_start(country,date,product,platform) {
    return {
        type: PRIZE_REQUEST_START,
        country:country,
        date:date,
        product:product,
        platform:platform
    };
}

export function prize_request_success(data) {
    return {
        type: PRIZE_REQUEST_SUCCESS,
        data:data
    };
}

export function prize_request_failed() {
    return {
        type: PRIZE_REQUEST_FAILED
    };
}

export function prize_request_no_permission() {
    return {
        type: PRIZE_REQUEST_NO_PERMISSION
    };
}

export function prize_open_update_form(order) {
    return {
        type: PRIZE_OPEN_UPDATE_FORM,
        order:order
    };
}

export function prize_delete(day,id) {
    return {
        type: PRIZE_DELETE,
        day: day,
        id:id
    };
}
export function prize_insert(order) {
    return {
        type: PRIZE_INSERT,
        order: order
    };
}

export function prize_update(prize,day) {
    return {
        type: PRIZE_UPDATE,
        prize: prize,
        day: day
    };
}

export function prize_update_field(field,value) {
    return {
        type: PRIZE_UPDATE_FIELD,
        field: field,
        value:value
    };
}

export function prize_stores_day(stores) {
    return{
        type: PRIZE_STORES_DAY,
        stores: stores
    }
}

export function prize_stores_day_manager(stores) {
    return{
        type: PRIZE_STORES_DAY_MANAGER,
        stores: stores
    }
}

export function prize_stores_day_manager_add(id,name) {
    return{
        type: PRIZE_STORES_DAY_MANAGER_ADD,
        id: id,
        name: name
    }
}

export function prize_stores_day_update(day,stores) {
    return{
        type: PRIZE_STORES_DAY_UPDATE,
        day: day,
        stores: stores
    }
}

export function prize_stores_day_manager_update(manager,day,stores) {
    return{
        type: PRIZE_STORES_DAY_MANAGER_UPDATE,
        manager: manager,
        day: day,
        stores: stores
    }
}

//
//
//Async Actions
//
//
export function fetchPrizeDataIfNeeded(queryParams,force) {
    var date = UrlParamsManager.getDate(queryParams);
    var status = UrlParamsManager.getStatus(queryParams);

    /*var provider = UrlParamsManager.getProvider(queryParams);
    var secondStatus = UrlParamsManager.getSecondStatus(queryParams);
    var store = UrlParamsManager.getStore(queryParams);*/

    return (dispatch, getState) => {
        if (shouldFetchPrizeData(getState(),date, status/*,provider,secondStatus,store*/) || force) {
            return dispatch(fetchPrizeData(date, status/*,provider,secondStatus,store*/));
        }
    };
}

function shouldFetchPrizeData(state,date,status/*,provider,secondStatus,store*/) {
    if (!state.prize.data){
        return true;
    }
    else if (state.prize.date !== date ||
        state.prize.status !== status /*
        state.prize.provider !== provider ||
        state.prize.secondStatus !== secondStatus ||
        state.prize.store !== store*/){
        return true;
    }
    else{
        return false;
    }
}

export function fetchPrizeDataForce(queryParams) {
    var date = UrlParamsManager.getDate(queryParams);
    return (dispatch, getState) => {
        dispatch(fetchPrizeData(date));
    }
}


function fetchPrizeData(date,status/*,provider,secondStatus,store*/) {
    var dateFilter = {
        filter:true,
        platform:'',
        value:date.date,
        range:{startDate:date.startDate,endDate:date.endDate}
    };

    var requestParams = {
        date:dateFilter,
        status:status,
        /*provider:parseInt(provider),
        secondStatus:parseInt(secondStatus),
        store:parseInt(store)*/
    };

    return ((dispatch) => {
        dispatch(prize_request_start(status));

        let request = 'prize/get';

        http.postToServer(request,
            requestParams,
            (response) =>  {dispatch(prize_request_success(response.data))},
            (response) =>  {dispatch(prize_request_failed())},
            (response) =>  {dispatch(prize_request_no_permission())}

        );

    });
}

/*export function fetchStoresByDay() {
    //console.log("Here")
    return ((dispatch) => {
        http.postToServer(
            'prize/stores_day',
            {},
            (response) => {dispatch(prize_stores_day(response.data))},
            (response) => {console.log('error fetchStoresByDay');
            }
        );

    });
}*/

export function fetchStoresByDayManager() {
    //console.log("Here")
    return ((dispatch) => {
        http.postToServer(
            'prize/stores_day_manager',
            {},
            (response) => {dispatch(prize_stores_day_manager(response.data))},
            (response) => {console.log('error fetchStoresByDay');
            }
        );

    });
}